import React, { Component } from 'react';

import RoomIcon from '@mui/icons-material/Room';
import { Container, Grid, Typography, Button, Stack } from '@mui/material';
import Paper from '@mui/material/Paper';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { breadcrumbNameMap } from '../../helpers/config';

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.addEventListener('popstate', event => {
      this.props.history.push('/');
      console.log(event);
    });
  }

  onClickGoBackShopping = () => this.props.history.push('/products');

  onClickTrackOrder = () => {
    const { checkout, auth } = this.props;
    const { orderId } = checkout;
    const { selectedSalesOrgData } = auth;
    const { CheckoutRule } = selectedSalesOrgData;
    const screenName = CheckoutRule === '02' ? 'orders' : 'quotations';
    this.props.history.push(`/${screenName}/${orderId}`);
  };

  render() {
    const { t, checkout, auth } = this.props;
    const { selectedSalesOrgData } = auth;
    const { CheckoutRule } = selectedSalesOrgData;
    const { orderId } = checkout;
    const { state } = this.props.location;
    const isConfirm = state !== undefined ? state.isConfirm : false;

    return isConfirm ? (
      <>
        <Container>
          <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
          <Grid
            item
            container
            xs={12}
            justifyContent="center"
            textAlign="center"
            alignItems="center"
            sx={{ pt: 6.25 }}
          >
            <Paper
              variant="outlined"
              square
              sx={{
                width: '80%',
                alignItems: 'center',
                pt: 6,
                pb: 2.5,
                paddingX: 2.5,
              }}
            >
              <Grid xs={12} item justifyContent="center" textAlign="center" alignItems="center">
                <Typography textAlign="center" sx={{ fontSize: 28, mb: 1.5 }}>
                  {CheckoutRule === '02' ? t('confirmationScreenTranslations:MSG1') : ''}
                </Typography>
              </Grid>
              <Grid
                xs={12}
                item
                justifyContent="center"
                textAlign="center"
                alignItems="center"
                marginTop="5px"
              >
                <Typography textAlign="center" sx={{ fontSize: 14, mb: 2.5 }}>
                  {CheckoutRule === '02'
                    ? t('confirmationScreenTranslations:MSG2')
                    : 'Sales Quotation has been created.'}
                </Typography>
              </Grid>
              <Grid
                xs={12}
                item
                justifyContent="center"
                textAlign="center"
                alignItems="center"
                marginTop="5px"
              >
                <Typography textAlign="center" sx={{ fontSize: 14, mb: 2.5 }}>
                  {CheckoutRule === '02'
                    ? t('confirmationScreenTranslations:MSG3')
                    : 'Make sure you make note of your sales quotation number, which is'}
                  &nbsp;
                  {orderId}
                </Typography>
              </Grid>
              <Stack
                container
                direction="row"
                justifyContent="center"
                sx={{ pt: 3, pb: 3 }}
                spacing={2}
              >
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={this.onClickGoBackShopping}
                  sx={{ ml: 2 }}
                >
                  {t('confirmationScreenTranslations:GO_BACK_SHOPPING')}
                </Button>
                <Button
                  color="primary"
                  startIcon={<RoomIcon />}
                  onClick={this.onClickTrackOrder}
                  sx={{ mr: 2 }}
                >
                  {CheckoutRule === '02'
                    ? t('confirmationScreenTranslations:TRACK_ORDER')
                    : 'Open Sales Quotation'}
                </Button>
              </Stack>
            </Paper>
          </Grid>
        </Container>
      </>
    ) : (
      <Redirect to={{ pathname: '/', state: { isCheckout: false } }} />
    );
  }
}

const mapStateToProps = state => {
  return {
    checkout: state.checkout,
    auth: state.auth,
  };
};
const cConfirmation = connect(mapStateToProps, {})(Confirmation);
const tConfirmation = withTranslation(['confirmationScreenTranslations'])(cConfirmation);
export { tConfirmation as Confirmation };
